import script from "./AuthButton.vue?vue&type=script&lang=js"
export * from "./AuthButton.vue?vue&type=script&lang=js"

import "./AuthButton.vue?vue&type=style&index=0&id=76e801aa&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e801aa"]])

export default __exports__